import 'angular:locale/data:fr';
import '@angular/localize/init';
import 'zone.js';(globalThis.$localize ??= {}).locale = "fr";
